.ConfirmDialog {
  --dialog-padding: var(--space);
  --dialog-width: 500px;
  --dialog-height: fit-content;
  container: unset;
}

.ConfirmDialogBody {
  padding: 4px 4px 0;
}

.ConfirmDialogActions {
  --dialog-actions-grid: auto / max-content max-content;
  justify-content: end;
}
